import { IHistoricalOrder, IServerOrder } from '@rbi-ctg/menu';
import { useFlag } from 'utils/launchdarkly';
import { getOrderNumber } from 'utils/order';

export default function useOrderNumber(
  serverOrder: IServerOrder | IHistoricalOrder
): string | null {
  const enableOrderNumberGeneration = useFlag('enable-order-number-generation');
  return getOrderNumber(serverOrder, enableOrderNumberGeneration);
}
